var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('vertical-bar-chart',{staticStyle:{"height":"200px"},attrs:{"chart-data":_vm.chartData,"options":_vm.options}}),_vm._v(" "),_c('div',{staticStyle:{"font-size":"0.8em","text-transform":"uppercase"}},[_vm._v("Membership Type Distribution")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a0db162","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/membership/MembershipTypeChart.vue
// module id = null
// module chunks = 